import { render, staticRenderFns } from "./data-download.vue?vue&type=template&id=383ecf59&"
import script from "./data-download.js?vue&type=script&lang=js&"
export * from "./data-download.js?vue&type=script&lang=js&"
import style0 from "./data-download.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports